import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, message } from 'antd';
import RequestHandbook from './Components/RequestHandbook';
import BatchTransferBa from './Components/BatchTransferBa';
import ProjectSplit from './Components/ProjectSplit';
import ConfigBa from './Components/ConfigBa';
import Filter from './Components/Filter';
import Log from './Components/Log';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/noticeActions';
import fp from '../../../utils/fp';
import cf from '../../../utils/cf';
import Detail from './Components/Detail';
import ConactInformation from './Components/ConactInformation';
import SigninContract from './Components/SigninContract';
import BigAccount from './Components/BigAccount';
import ExportFixedLine from './Components/ExportFixedLine';

class ResponseCustomer extends Component {
    constructor(props) {
        super(props);
        const { params: { customerCompanyName, customerCompanyId, userId, userNameCode } = {} } = props;
        const searchParams = {};
        if (customerCompanyName && customerCompanyId) {
            searchParams.customerCompanyId = customerCompanyId;
            searchParams.customerCompany = { text: customerCompanyName, value: customerCompanyId };
        }
        if (userId) {
            searchParams.userId = userId;
            searchParams.user = { text: userNameCode, value: userId };
        }
        const { curRole } = sessionStorage;
        this.confBa = curRole === 'CSAL';
        this.batchTransferBa = curRole === 'CSAL';
        this.isBAL = curRole === 'BAL';
        this.state = {
            data: [],
            loading: false,
            searchParams,
            curParams: {...searchParams},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            canOperate: false,
            TypeList: [],
        };
    }

    componentDidMount() {
        this.loadData();
        this.queryOperation();
        this.queryTypeListByUserId();
    }

    componentWillUnmount() {
        this.props.saveParams({
            customerCompanyId: undefined,
            customerCompanyName: undefined,
            userId: undefined,
            userNameCode: undefined,
        });
    }

    loadData = () => {
        const { curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(curParams);

        Fetch.post(API_URL.contract.queryCustomerCompanyBaList, {
            offset: current,
            limit: pageSize,
            ...params,
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    queryOperation = () => {
        Fetch.post(API_URL.contract.queryCustomCompanyOperator, {

        }).then(res => {
            const { canOperate } = res;
            this.setState({ canOperate })
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    queryTypeListByUserId = () => {
        Fetch.post(API_URL.contract.queryTypeListByUserId, {

        }).then(res => {
            const { list } = res;
            this.setState({ TypeList: list })
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: { ...searchParams },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { curParams } = this.state;
        const params = this.splitParams(curParams);
        const url = API_URL.contract.exportCustomerCompanyBaList;
        ExportUtil.export({ ...params }, null, url);
    }

    confirmDirectly = record => {
        Modal.confirm({
            iconType: 'exclamation-circle',
			title: <div style={{ marginLeft: 42 }}>确认此项目在该月的未确认工时无需继续确认？</div>,
			content: '标记为无需继续确认，那么该月的未确认工时项目清单中，不再显示此项目',
            onOk: () => {
                const { hourId, hourType } = record;
				Fetch.post(API_URL.execute.comfirmUserFteMonthOne, {
                    hourId,
                    hourType,
                }).then(() => {
                    message.success('确认成功');
                    this.loadData();
                }).catch(err => {
                    console.error(err);
                });
            }
        });
    }

    queryStatus = () => {
        if (this.confBa) {
            this.batchTransfer();
        } else {
            Fetch.post(API_URL.contract.queryBaHandByUserId).then((res) => {
                if (res.data) {
                    const { userId, userName, employeeCode, details } = res.data;
                    const result = {
                        baUserId: userId,
                        baUserName: format('joint', userName, employeeCode),
                        recipients: [],
                    };
                    (details || []).forEach(detail => {
                        const { handOverUserId, userName, employeeCode, detailList } = detail;
                        result.recipients.push({
                            userId: handOverUserId,
                            userName: format('joint', userName, employeeCode),
                            companys: detailList,
                        });
                    });
                    this.batchTransfer(result);
                } else {
                    this.batchTransfer();
                }
            }).catch(err => {
                console.error(err);
            });
        }
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const { curRole, userId } = sessionStorage;
        const isCSA = curRole === 'CSA';
        const isCSAL = curRole === 'CSAL';
        const isBAL = curRole === 'BAL';
        const isBA = curRole === 'BA';
        const columns = [{
            title: '客户名称',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 160,
        }, {
            title: '客户代码',
            dataIndex: 'customerCompanyCode',
            key: 'customerCompanyCode',
            width: 70,
        }, {
            title: '客户标签',
            dataIndex: 'customerTagValue',
            key: 'customerTagValue',
            width: 100,
        }, {
            title: '合同约定账期',
            dataIndex: 'contractAgreedPaymentTerms',
            key: 'contractAgreedPaymentTerms',
            width: 80,
        },{
            title: '有无请款手册',
            dataIndex: 'enclosureFileCount',
            key: 'enclosureFileCount',
            width: 40,
            render: text => {
                if(text && Number(text) > 0){
                    text = '有';
                }else{
                    text = '无';
                }
                return text;
            }
        }]
        columns.push(
            {
                title: '是否内部公司不计入',
                dataIndex: 'internalCompanyExcludeIncome',
                key: 'internalCompanyExcludeIncome',
                width: 40,
                render: text => text == 1 ? '是' : '否'
            }, {
                title: '关联医院',
                dataIndex: 'relateHospitalName',
                key: 'relateHospitalName',
                width: 140,
            }, {
                title: '大客户经理',
                dataIndex: 'keyAccountManagerName',
                key: 'keyAccountManagerName',
                width: 140,
            }, {
                title: '客户CSA',
                dataIndex: 'csa',
                key: 'csa',
                width: 100,
                render: (text, record) => {
                    const { csaList } = record;
                    return (
                        (csaList || []).map((item, index, arr) => {
                            const { userId, employeeCode, userCompellation } = item;
                            return <span key={userId}>{userCompellation}[{employeeCode}]{index < arr.length - 1 && '；'}{(index + 1) % 2 === 0 && <br />}</span>;
                        })
                    )
                }
            }, {
                title: '客户BA',
                dataIndex: 'ba',
                key: 'ba',
                width: 120,
                render: (text, record) => {
                    const { baList } = record;
                    return (
                        (baList || []).map((item, index, arr) => {
                            const { userId, employeeCode, userCompellation } = item;
                            return <span key={userId}>{userCompellation}[{employeeCode}]{index < arr.length - 1 && '；'}{(index + 1) % 2 === 0 && <br />}</span>;
                        })
                    )
                }
            }, {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 140,
                fixed: 'right',
                render: (text, record) => {
                    const { baList, canSetAgreedPaymentTerms, csaList } = record;
                    const { canOperate, TypeList } = this.state;
                    const hasMultipleBa = (csaList || []).length > 1;
                    const isCurCSA_CSAL = (isCSA && csaList.some(i => i.userId == userId)) || isCSAL;
                    const canProjectSplit = hasMultipleBa && isCurCSA_CSAL;
                    const canConfigBA = TypeList.some(i => i == 'CUSTOMER_COMPANY_SET_BA');
                    // const canBatchTransferBa = TypeList.some(i => i == 'CUSTOMER_COMPANY_HANDOVER_BA');
                    const canSplit = TypeList.some(i => i == 'CUSTOMER_COMPANY_SPLIT_BA_INV');
                    const canBASplit = canSplit || isBAL;
                    const operationCorrespondRoles = new Map([
                        ['configBA', {
                            name: '配置BA',
                            display: canConfigBA || isBAL,
                            editable: true,
                            event:  () => this.configBa(record,'BA'),
                            roles: ['*'],
                        }],
                        ['signinContract', {
                            name: '登记合同约定账期',
                            display: isCurCSA_CSAL || canSetAgreedPaymentTerms ,
                            editable: true,
                            event:  () => this.showSigninContract(record),
                            roles: ['*'],
                        }],
                        ['configCSA', {
                            name: '配置CSA',
                            display: this.confBa || canOperate,
                            editable: true,
                            event: () => this.configBa(record,'CSA'),
                            roles: ['*'],
                        }],
                        ['associate', {
                            name: '交接日志',
                            display: !(isBA || isBAL || isCSA) || canOperate,
                            editable: true,
                            event:  () => this.showLog(record),
                            roles: ['*'],
                        }],
                        ['detail', {
                            name: '项目明细',
                            display: true,
                            editable: true,
                            event:  () => this.showDetail(record),
                            roles: ['*'],
                        }],
                        ['split', {
                            name: '项目拆分',
                            display: (canProjectSplit && !isCSA && csaList.length > 1) || (canOperate && csaList.length > 1) || (canSplit && baList.length > 1) || (isBAL && baList.length > 1),
                            editable: true,
                            event: () => this.proSplit(record, isCSA, isBA, canBASplit, canOperate),
                            roles: ['*'],
                        }],
                        ['cashout', {
                            name: '请款手册',
                            display: ( isBAL || isBA || isCSA || isCSAL || curRole === 'BD' || curRole ==='BDO' || curRole === 'BDM'),
                            editable: true,
                            event: () => this.requestHandbook(record, isCurCSA_CSAL),
                            roles: ['*'],
                        }],
                        ['conactinformation', {
                            name: '联系人信息',
                            display: true,
                            editable: true,
                            event: () => this.showConactInfo(record),
                            roles: ['*'],
                        }],
                        ['bigAccount', {
                            name: '配置大客户经理',
                            display: curRole === 'BO',
                            editable: true,
                            event: () => this.showBigAccount(record),
                            roles: ['*'],
                        }],
                    ]);
                    return (
                        <span>
                            {   fp.compose(
                                    fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                                    fp.filter(i => !!i),
                                    // 获取角色对应操作
                                    fp.curry(cf.authDomList)(operationCorrespondRoles)
                                )(curRole)
                            }
                        </span>
                    );
                },
            }
        )

        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showBigAccount = (record) => {
        this.BigAccountRef.show(record);
    }

    showSigninContract = (record) => {
        this.SigninContractRef.show(record);
    }

    showLog = (record) => {
        this.logRef.show(record);
    }

    showDetail = (record) => {
        this.detailRef.show(record);
    }

    requestHandbook = (record, editable) => {
        this.handbookRef.show(record, editable);
    }

    showConactInfo = (record) => {
        this.conactinformationRef.show(record);
    }

    configBa = (record, type) => {
        this.configBaRef.show(record, type);
    }

    proSplit = (record, isCSA, isBA, canBASplit, canOperate) => {
        this.proSplitRef.show(record, isCSA, isBA, canBASplit, canOperate);
    }

    batchTransfer = (data, canBABatchTransferBa) => {
        this.batchTransferRef.show(data, canBABatchTransferBa);
    }

    showFixedLine = () => {
        this.exportFixedLineRef.show();
    }

    render() {
        const { data, loading, pagination, searchParams, canOperate, TypeList } = this.state;
        const canBatchTransferBa = TypeList.some(i => i == 'CUSTOMER_COMPANY_HANDOVER_BA');
        const canBABatchTransferBa = canBatchTransferBa || this.isBAL;
        return (
            <div className="content">
                <SideNav selectKey="responseCustomer" />
                <div className="main">
                    <div className="main-content">
                        <Filter
                            search={this.search}
                            params={searchParams}
                            onChange={this.handleFilterChange}
                            buttons={[
                                <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                                <Button className="btn-yellow" onClick={this.showFixedLine}>导出固化数据</Button>,
                                (this.batchTransferBa || canOperate) && <Button key="batchTransfer" type="primary" onClick={this.queryStatus}>CSA批量交接</Button>,
                                (canBatchTransferBa || this.isBAL) && <Button type="primary" onClick={() => this.batchTransfer(null,canBABatchTransferBa)}>BA批量交接</Button>
                            ]}
                        />
                        <TableC
                            data={data}
                            scrollY={500}
                            loading={loading}
                            columns={this.getColumns()}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                        <RequestHandbook ref={el => this.handbookRef = el} loadData={this.loadData} />
                        <BatchTransferBa ref={el => this.batchTransferRef = el} loadData={this.loadData} />
                        <ProjectSplit ref={el => this.proSplitRef = el} loadData={this.loadData} />
                        <ConfigBa ref={el => this.configBaRef = el} loadData={this.loadData} />
                        <Log ref={el => this.logRef = el} />
                        <Detail ref={el => this.detailRef = el} params={searchParams}/>
                        <ConactInformation ref={el => this.conactinformationRef = el} />
                        <SigninContract ref={el => this.SigninContractRef = el} loadData={this.loadData} />
                        <BigAccount ref={el => this.BigAccountRef = el} loadData={this.loadData} />
                        <ExportFixedLine ref={el => this.exportFixedLineRef = el}/>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResponseCustomer);


// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/index.js